module.exports = __webpack_public_path__ + "static/visualstudio-17932dcf5efe54e5fac6c31627127d9c.svg";